import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiPublishedStatuses extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}